// extracted by mini-css-extract-plugin
export default {"root":"RecipeItems_root__7tt5a","accordion-heading":"RecipeItems_accordion-heading__Mpz+s","indicator":"RecipeItems_indicator__6tz1+"};